module.exports = __webpack_public_path__ + "static/img/popup.b0ba34fb.svg";